import React from "react";
import { SPORTS } from "../../mock";
import * as LucideIcons from "lucide-react";
import { SectionTitle } from "./About";

export default function Sports() {
  return (
    <section id="sports" className="scroll-smooth-section py-24 bg-emerald-deep relative overflow-hidden">
      <div className="absolute -top-32 -right-20 w-[500px] h-[500px] rounded-full bg-gold/5 blur-3xl" />
      <div className="absolute -bottom-32 -left-10 w-[400px] h-[400px] rounded-full bg-gold/5 blur-3xl" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="max-w-3xl text-ivory">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-10 bg-gold" />
            <span className="text-xs tracking-[0.3em] uppercase text-gold font-medium">Body & Spirit</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl leading-tight">An athlete, a martial artist <span className="text-gold italic">— a complete man</span></h2>
          <p className="mt-4 text-ivory/80 text-lg">Beyond the operating room and the writing desk, Dr. Shaji has lived a vigorously physical life — from state-level football to leading the Kerala Kalaripayattu Association.</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SPORTS.map((s, i) => {
            const Icon = LucideIcons[s.icon] || LucideIcons.Trophy;
            return (
              <div key={i} className="bg-ivory/5 backdrop-blur border border-ivory/10 rounded-2xl p-6 lift hover:bg-ivory/10">
                <div className="w-12 h-12 rounded-full bg-gold/15 flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-gold" />
                </div>
                <div className="font-display text-ivory text-lg leading-snug">{s.title}</div>
                <p className="text-ivory/70 text-sm mt-2 leading-relaxed">{s.detail}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <p className="font-serif-accent italic text-2xl text-gold max-w-3xl mx-auto">
            “A healthy body is the chamber of a healthy mind. Medicine without movement is incomplete.”
          </p>
        </div>
      </div>
    </section>
  );
}
